export default class UI_GoalPanelPoints extends Phaser.Group {
  /**
   * The goal panel for when its collecting points rather than gems
   * @param {number} x
   * @param {number} y
   */
  constructor(x, y) {
    super(game);

    this.x = G.l(x);
    this.y = G.l(y);

    this._state = game.state.getCurrentState(); // Game.js

    this._objectsToCollect = JSON.parse(JSON.stringify(G.lvlData.goal[1]));

    this._labelTxt = new G.Text(0, 0, `/${G.lvlData.goal[1]}`, G.OMTsettings.elements.UI_GoalPanelPoints.labelTxt.style, [0, 0.5], 150);

    this._pointsCounter = new G.Text(0, 0, 0, G.OMTsettings.elements.UI_GoalPanelPoints.pointsCounter.style, 0.5, 300);
    // eslint-disable-next-line prefer-destructuring
    this.add(this._labelTxt);
    this.add(this._pointsCounter);

    this._signalBinding = G.sb('onScreenResize').add(this._onScreenResize, this);
    this._onScreenResize();
  }

  /**
   * Destroy!
   */
  destroy() {
    if (this._signalBinding) {
      if (this._signalBinding.detach) {
        this._signalBinding.detach();
      }
      this._signalBinding = null;
    }
    super.destroy();
  }

  /**
   * Updates text
   */
  update() {
    this.centerTexts();
    this._pointsCounter.setText(this._state.topBar.pointsCounter.text);
  }

  /**
   * Repositions layout
   */
  _onScreenResize() {
    this._pointsCounter.anchor.x = 1;
    this._labelTxt.y = this._pointsCounter.y = 0;

    this._pointsCounter.updateText();
    this._pointsCounter.updateCache();

    this.centerTexts();
  }

  /**
   * Keeps it centered
   */
  centerTexts() {
    const xx = (this._pointsCounter.width + this._labelTxt.width) * -0.5;
    this._pointsCounter.x = xx + this._pointsCounter.width;
    this._labelTxt.x = xx + this._pointsCounter.width;
  }
}
